// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".outWx[data-v-7541d790]{width:100vw;height:100vh;display:flex;flex-direction:column;align-items:center}.outWx .icon[data-v-7541d790]{width:5.5rem;height:5.5rem;margin-top:7.875rem}.outWx .tips[data-v-7541d790]{font-size:1.125rem;color:#000;line-height:1.3125rem;font-weight:700}", ""]);
// Exports
module.exports = exports;
